import angular from 'angular';

import SchwackeAPIController from './schwacke-api.controller';

export default angular.module('autoboard.schwackeAPIComponent', [])
  .controller('SchwackeAPIController', SchwackeAPIController)
  .name;
